import { render, staticRenderFns } from "./FiscalizacaoDetalhar.vue?vue&type=template&id=654f1080&"
import script from "./FiscalizacaoDetalhar.vue?vue&type=script&lang=js&"
export * from "./FiscalizacaoDetalhar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports